import { createReducer } from "../../core/core-redux/reducer/createReducer";
import { GEOCALC_LIST_LOADED, loadGeoCalculationsReducer } from "./loadGeoCalculations";
import { GEOCALC_GEOMETRY_LOADED, loadVisualisedGeoCalculationReducer } from "./loadVisualisedGeoCalculation";
import { GEOCALC_GEOMETRY_REMOVED, removeGeoCalculationReducer } from "./removeGeoCalculation";
import { GEOCALCULATION_VISIBILITY_TOGGLED, setGeoCalculationVisibilityReducer } from "./setGeoCalculationVisibility";
import { GeoCalcState } from "../types";

export const geoCalcListReducer = createReducer<GeoCalcState>(
    {
        enabled: true,
        items: [],
    },
    {
        [GEOCALC_LIST_LOADED]: loadGeoCalculationsReducer,
        [GEOCALC_GEOMETRY_LOADED]: loadVisualisedGeoCalculationReducer,
        [GEOCALC_GEOMETRY_REMOVED]: removeGeoCalculationReducer,
        [GEOCALCULATION_VISIBILITY_TOGGLED]: setGeoCalculationVisibilityReducer,
    }
);
